import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAskUserPopup, setCountinueWithWeb } from "../../../../reducers/common-reducer";
import { goToPlayStore } from "../../../../shared/utility";
import Localize from "../../../../locale/Localize";
import { DefaultLanguage } from "../../../../constants/LanguageConstants";
import { PublicVariables } from "../../../../constants/PublicVariables";
import CenterModal from "../../../UI/Modal/CenterModal";

const AskGuestUserPopup = () => {
    const dispatch = useDispatch();
    const { askUserPopup, countinueWithWeb } = useSelector((state) => state.commonReducer);
    const { selectedLanguageData } = useSelector((state) => state.language);

    const [localisedValues, setLocalisedValues] = useState({});

    useEffect(() => {
        setLocalisedValues(Localize[selectedLanguageData?.languageCode ?? DefaultLanguage]);
    }, [selectedLanguageData]);

    const handleDownloadApp = () => {
        handleClosePopup();
        dispatch(setCountinueWithWeb(true));
        goToPlayStore();
    };

    const handleCountinueButton = () => {
        dispatch(setCountinueWithWeb(true));
        handleClosePopup();
    };

    const askUserHeader = (
        <>
            <h5 className='modal-title'>{Localize[PublicVariables.currentLanguageObj.languageCode]["message_title"]}</h5>
            <button type='button' className='btn-close' aria-label='Close' onClick={() => handleClosePopup()}>
                <span className='btn-icon icon-close-light'></span>
            </button>
        </>
    );

    const askUserBody = (
        <div className='privacy-policy-modal-text'>
            <p>{Localize[PublicVariables.currentLanguageObj.languageCode]["would_you_like_to_install_app_or_continue_browser"]}</p>
        </div>
    );

    const askUserFooter = (
        <div className='button-inline more-space button-inline-tb-space d-flex align-items-center'>
            <div className='button'>
                <button className='btn default-btn-link' onClick={() => handleDownloadApp()}>
                    {localisedValues["download_app"]}
                </button>
            </div>
            <div className='button'>
                <button className='btn default-btn-primary' onClick={() => handleCountinueButton()}>
                    {localisedValues["continue_initcap"]}
                </button>
            </div>
        </div>
    );

    const handleClosePopup = () => {
        dispatch(setAskUserPopup(false));
    };

    return (
        <>
            {!countinueWithWeb && (
                <CenterModal
                    showModal={askUserPopup}
                    closeModal={() => handleClosePopup()}
                    modalClass='default-modal modal-medium mob-bottom-top'
                    className='modal-dialog modal-dialog-centered'
                    header={askUserHeader}
                    body={askUserBody}
                    footer={askUserFooter}
                    backdrop={"static"}
                />
            )}
        </>
    );
};

export default AskGuestUserPopup;
